import { useTranslation } from "react-i18next";

const isClass11th = (className?: string): boolean => {
  const v = String(className || "").toLowerCase();
  if (!v) return false;
  // matches "11th", "11", "class 11", etc.
  return v.includes("11th") || v.match(/\b11\b/) != null;
};

export const useMarksheetTypeOptions = (className?: string) => {
  const { t } = useTranslation();

  // UI requirement:
  // - For most classes, show "Final" for ANNUAL (payload remains ANNUAL).
  // - For 11th, show both "Annual" and "Final" (Final maps to ANNUAL in payload).
  const annualOption =
    isClass11th(className)
      ? { value: "ANNUAL", label: t("annual") }
      : { value: "ANNUAL", label: t("final") };

  return [
    { value: "MONTHLY", label: t("monthly") },
    { value: "QUARTERLY", label: t("quarterly") },
    { value: "HALF_YEARLY", label: t("half_year") },
    { value: "PRE_BOARD", label: t("pre_board") },
    { value: "BOARD", label: t("board") },
    annualOption,
    ...(isClass11th(className) ? [{ value: "FINAL", label: t("final") }] : []),
  ];
};

export const useMonthTypeOptions = () => {
  const { t } = useTranslation();
  
  return [
    { value: "JANUARY", label: t("january") },
    { value: "FEBRUARY", label: t("february") },
    { value: "MARCH", label: t("march") },
    { value: "APRIL", label: t("april") },
    { value: "MAY", label: t("may") },
    { value: "JUNE", label: t("june") },
    { value: "JULY", label: t("july") },
    { value: "AUGUST", label: t("august") },
    { value: "SEPTEMBER", label: t("september") },
    { value: "OCTOBER", label: t("october") },
    { value: "NOVEMBER", label: t("november") },
    { value: "DECEMBER", label: t("december") },
    { value: "NA", label: "NA" },
  ];
};

// Keep the original exports for backward compatibility
export const MARKSHEET_TYPE_OPTIONS = [
  { value: "MONTHLY", label: "monthly" },
  { value: "QUARTERLY", label: "quarterly" },
  { value: "HALF_YEARLY", label: "half_year" },
  { value: "PRE_BOARD", label: "pre_board" },
  { value: "BOARD", label: "board" },
  { value: "ANNUAL", label: "annual" },
];

export const MONTH_TYPE_OPTIONS = [
  { value: "JANUARY", label: "january" },
  { value: "FEBRUARY", label: "february" },
  { value: "MARCH", label: "march" },
  { value: "APRIL", label: "april" },
  { value: "MAY", label: "may" },
  { value: "JUNE", label: "june" },
  { value: "JULY", label: "july" },
  { value: "AUGUST", label: "august" },
  { value: "SEPTEMBER", label: "september" },
  { value: "OCTOBER", label: "october" },
  { value: "NOVEMBER", label: "november" },
  { value: "DECEMBER", label: "december" },
  { value: "NA", label: "NA" },
];

// Helper function to check if a marksheet type should use NA for month type
export const shouldUseNAForMonthType = (marksheetType: string): boolean => {
  return ["QUARTERLY", "ANNUAL", "BOARD", "PRE_BOARD", "HALF_YEARLY", "SAHSHEKSHIK"].includes(marksheetType);
};
